import { styled } from "@mui/material/styles";
import colors from "../../constants/colors";

export const LoaderContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "3rem 1.5rem",
  minHeight: "60vh",
  gap: "2rem",
  width: "100%",
});

export const LoaderTitle = styled("h1")({
  fontSize: "clamp(1.75rem, 5vw, 2.5rem)",
  fontWeight: 800,
  background: colors.GRADIENT_PURPLE,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
  direction: "rtl",
  letterSpacing: "-0.02em",
  lineHeight: 1.2,
  marginBottom: "0.5rem",
  marginTop: 0,
  textAlign: "center",
});

export const LoaderSubtitle = styled("h2")({
  fontSize: "clamp(1rem, 3vw, 1.25rem)",
  fontWeight: 600,
  color: colors.GREY_7,
  direction: "rtl",
  lineHeight: 1.5,
  marginTop: 0,
  marginBottom: "1.5rem",
  textAlign: "center",
});
